var _defs, _rect, _path, _rect2, _rect3, _path2, _path3, _polygon, _polygon2, _polygon3, _path4, _path5, _line, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _rect4, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _circle, _g2, _path26, _path27, _path28, _path29, _path30, _text, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _g3, _path31, _path32, _path33, _path34, _path35, _g4, _g5, _path36, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _g6, _path37, _path38, _path39, _rect10, _path40, _path41, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogovisualelementstab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 765 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-15,.cls-2,.cls-20,.cls-25,.cls-28,.cls-30,.cls-8{fill:none;}.cls-1,.cls-20,.cls-30{stroke:#2f2143;}.cls-1,.cls-15,.cls-20,.cls-25,.cls-28,.cls-30,.cls-8{stroke-miterlimit:10;}.cls-1{stroke-width:2.28px;}.cls-3{fill:#d8c4df;}.cls-4{fill:#af705c;}.cls-5{fill:#263238;}.cls-6{fill:#e6e6e6;}.cls-7{fill:#fdc435;}.cls-8{stroke:#263238;stroke-width:0.64px;}.cls-19,.cls-9{fill:#2f2143;}.cls-10{fill:#a34f40;}.cls-11{clip-path:url(#clip-path);}.cls-12{fill:#fff;}.cls-13{fill:#f04a49;}.cls-14{fill:#e0e1e0;}.cls-15{stroke:#293b4a;stroke-width:1.5px;}.cls-16{opacity:0.5;}.cls-17{clip-path:url(#clip-path-2);}.cls-18{fill:#293b4a;}.cls-19{font-size:35px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-20{stroke-width:1.46px;}.cls-21{clip-path:url(#clip-path-3);}.cls-22{fill:#9a499c;}.cls-23{fill:#f2d686;}.cls-24{fill:#2e1f42;}.cls-25{stroke:#4f4e4f;stroke-width:0.78px;}.cls-26{clip-path:url(#clip-path-4);}.cls-27{clip-path:url(#clip-path-5);}.cls-28{stroke:#2e1f42;stroke-width:1.11px;}.cls-29{clip-path:url(#clip-path-6);}.cls-30{stroke-width:0.72px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -0.57)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 172.2,
    y: 106.6,
    width: 5.74,
    height: 5.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 -0.57)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 42.45,
    y: 142.39,
    width: 30.42,
    height: 30.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 -0.57)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 597.77,
    y: 107.78,
    width: 32.66,
    height: 37,
    transform: "translate(-12.85 125.87) rotate(-11.58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0 -0.57)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 600.56,
    y: 112.31,
    width: 7.96,
    height: 7.47,
    transform: "translate(-10.99 123.75) rotate(-11.58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0 -0.57)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 599.05,
    y: 111.23,
    width: 11.16,
    height: 10.48,
    transform: "translate(-11.07 123.77) rotate(-11.58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(0 -0.57)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 654.99,
    y: 19.3,
    width: 41.82,
    height: 41.75,
    transform: "translate(9.17 158.2) rotate(-13.44)"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo &amp;amp; visual elements tab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 765,
    height: 277
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M231.13,170.78c.73-3.07,2-4.3,2.48-4.73a13.94,13.94,0,0,1,1.87-1.39c.8-.43,1.31-.53,1.68-1.08a2.79,2.79,0,0,0,.33-1.53,49.33,49.33,0,0,1,1.49-6c3-9.93,8.08-8,6.24-1.75-.66,2.26-.62,3.42-.37,4.21s.46.77.94,1.92a14.75,14.75,0,0,1,.87,3c.34,2.31-.61,4.35-1.45,6.17a18.82,18.82,0,0,1-4.3,5.8,18.52,18.52,0,0,1-1.93,1.54Z",
    transform: "translate(0 -0.57)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.93,
    y: 103.73,
    width: 2.04,
    height: 3.41,
    transform: "translate(5.05 221.47) rotate(-48.68)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 278.96,
    y: 130.46,
    width: 2.04,
    height: 3.41,
    transform: "translate(9.55 282.34) rotate(-54.4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M293.81,112.93a1.33,1.33,0,1,1,1-1.59,1.32,1.32,0,0,1-1,1.59",
    transform: "translate(0 -0.57)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M251.9,90.26a1.26,1.26,0,1,1,.94-1.51,1.26,1.26,0,0,1-.94,1.51",
    transform: "translate(0 -0.57)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "263.71 147.51 249.19 154.97 233.91 143.21 237.27 126.47 273.55 102.85 270.5 116.25 263.71 147.51"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "245.04 160.5 228.67 148.16 233.34 142.19 249.7 154.53 245.04 160.5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "266.98 111.71 268.08 112.67 249.71 138.11 248.6 137.15 266.98 111.71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M252.64,139.39a3.38,3.38,0,1,1-.58-4.75h0a3.37,3.37,0,0,1,.58,4.74",
    transform: "translate(0 -0.57)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M248.28,104.94c7.61-7,19.45-8.17,27.3-2.52,8.84,6.37,11.28,19.44,4.72,29.26",
    transform: "translate(0 -0.57)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 251.7,
    y1: 88.51,
    x2: 293.35,
    y2: 111.09
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M200.69,152.21a18.65,18.65,0,0,1,2.63,9.25c.09,2.63,1.9,35.23,1.9,35.23l25.57-26.9,11.26,5.38s-23.9,34.21-34.06,38.19-17.48,2.13-19.79-.92-4.83-44.54-4.83-44.54Z",
    transform: "translate(0 -0.57)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M145,237c1.08-.42,11.62-4.34,19.46,1,1.6,1.1,3,2.58,9.49,23,3,9.37,2.32,16,2.32,16s-2.39.1-5.6,0c-1.86-.06-3,.15-12.62,0-6.72-.11-18.77.43-27.52,0a3.66,3.66,0,0,1-1.9-.55c-3.3-2.17-1.55-10.25-1-13C129.29,256.21,132.38,242,145,237Z",
    transform: "translate(0 -0.57)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M132.17,227.42c9.11,5.23,12.36,14,10.22,21.88-2.54,9.37.33,27.68-9.41,27.74-22.54.13-13.89-.07-27.12.11-10.06.15-18.77-.1-18.77-.1s10.43-23.46,16.08-37c5.89-14.14,27.36-13.59,29-12.62",
    transform: "translate(0 -0.57)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.33,153.39s15.92-11,18.43-11.34,3.47,11.65,1.61,17c-1.08,3.13-7.48,3-14.12,4.19Z",
    transform: "translate(0 -0.57)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M101.7,230.9c22.67,9.18,45,12.09,66.68,4.79,0,0,10.35-63.31,32.31-83.45a53.92,53.92,0,0,0-11.34-9.35,68.71,68.71,0,0,0-30.14-10.43A78.76,78.76,0,0,0,134.76,134s-30.18,35.08-33.06,97",
    transform: "translate(0 -0.57)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M136.58,133.6c10.35-1.75,29.47,51.12,38.36,52.19s52.39-32.4,52.39-32.4l5.92,9.88s-38,40.75-56.45,44.82-53-48.9-52.17-59,4.55-14.22,12-15.46",
    transform: "translate(0 -0.57)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.58,133.66C159.53,141,180.76,151.39,188.2,144c-4.07-3-5.06-6.21-4.56-9.29a14.25,14.25,0,0,1,2.19-5.26,29.25,29.25,0,0,1,1.84-2.61l-9-18.7c-1.79,8.23-6,26.81-17.06,25.49",
    transform: "translate(0 -0.57)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M209.57,92.17s2.72,12.68-5.13,19.2-9.74-22.43-9.74-22.43Z",
    transform: "translate(0 -0.57)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.89,101.45c0,11.36-.31,17.76,5.19,23.93,8.27,9.29,22.64,5.25,26.18-5.86,3.19-10,2.73-26.9-8.38-32.12-10.94-5.13-22.95,2.69-23,14",
    transform: "translate(0 -0.57)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M175.07,87.75c2-6.11,18.08-5,22.35-1.52.64.53-9.18,4.49-8.6,4.32l-4.57,1.19c-.68-.2-2.09.48-2.93,2.52,0,0-.65,17.37-6,22-3.93-2.22-3.71-9.1-4.71-13.29-1.5-6.23-3.2-15.32,4.5-15.24",
    transform: "translate(0 -0.57)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M190,104.63c-.08,1.16.49,2.13,1.27,2.18s1.48-.85,1.56-2-.5-2.14-1.27-2.19-1.48.85-1.56,2",
    transform: "translate(0 -0.57)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M201.64,106.92c-.08,1.15.49,2.13,1.27,2.18s1.47-.85,1.55-2-.49-2.13-1.27-2.18-1.48.85-1.55,2",
    transform: "translate(0 -0.57)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M199.21,106.07q.67,1,1.26,2l1.16,2.07,2.39,4.09.47.79-.88-.09a19.66,19.66,0,0,0-5.07.17,10.36,10.36,0,0,1,5.13-1.08l-.42.7a29.73,29.73,0,0,1-2.41-4.17,21.64,21.64,0,0,1-.9-2.23C199.66,107.6,199.41,106.84,199.21,106.07Z",
    transform: "translate(0 -0.57)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M190.15,98.63a.56.56,0,0,0,.56,0,4.59,4.59,0,0,1,4-.59.57.57,0,0,0,.73-.29.53.53,0,0,0-.3-.71,5.74,5.74,0,0,0-5.06.69.53.53,0,0,0-.14.75.52.52,0,0,0,.21.18",
    transform: "translate(0 -0.57)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.53,107.61a2.15,2.15,0,0,1,2.28-.57,3.63,3.63,0,0,1,1.89,1.56,5.56,5.56,0,0,1,.91,2.78",
    transform: "translate(0 -0.57)"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 172.2,
    y: 106.04,
    width: 5.74,
    height: 5.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M209.82,100.85a.58.58,0,0,0,.29-.13.54.54,0,0,0,0-.77,5.66,5.66,0,0,0-4.7-1.89.56.56,0,0,0-.47.62.57.57,0,0,0,.63.46,4.36,4.36,0,0,1,3.7,1.53.59.59,0,0,0,.5.18",
    transform: "translate(0 -0.57)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M172.64,111.85c-2-10-.2-20.63,2.38-23.57s15.54,4.64,15.54,4.64c-3-.81-6.07,1.73-5.1,4.78,1.36,4.23-1.36,10.54-4.7,12.91,0,0,0-1.79-1.53-1.45s-2.74,9.57,0,14.2c0,0-4.58-1.55-6.55-11.51",
    transform: "translate(0 -0.57)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.8,109.88a10.67,10.67,0,0,0,5.51,6c3.4,1.56,5.68-1.36,5.23-4.86-.43-3.13-2.71-7.79-6.34-7.83s-5.56,3.43-4.4,6.7",
    transform: "translate(0 -0.57)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M210.78,90.55s-3.45,4.07-13.49,3.07a27.71,27.71,0,0,0,6.79-1.46s-13.46,1.87-19.89-.55-8-5-8-5,1.1-6.79,16-5.93,19.6,7.29,18.6,9.82",
    transform: "translate(0 -0.57)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M196.79,119.45a31.44,31.44,0,0,0-3.32,3.31c-.24-.14-.48-.28-.7-.44-3.17-2-4-4-3.91-5.56a4.88,4.88,0,0,1,.68-2.19,4.68,4.68,0,0,1,.79-1c1,2.07,3.84,4.16,5.39,5.21.69.43,1.07.71,1.07.71",
    transform: "translate(0 -0.57)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M195.77,118.73l-1,1c-3-1.89-4.81-3.61-5.18-5.12a5,5,0,0,1,.79-1c1,2.08,3.85,4.16,5.4,5.21",
    transform: "translate(0 -0.57)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M192.81,122.31c-3.17-2-4-4-3.9-5.56a12,12,0,0,1,3.07,2.92,4.45,4.45,0,0,1,.83,2.64",
    transform: "translate(0 -0.57)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M38.26,28.79a14.54,14.54,0,0,0-2.06,5L33.42,34v5.38l2.78.26a14.54,14.54,0,0,0,2.06,5L36.48,46.8l3.81,3.8,2.15-1.77a14.35,14.35,0,0,0,5,2.05l.27,2.78h5.38l.26-2.78a14.32,14.32,0,0,0,5-2.05l2.15,1.77,3.8-3.8-1.77-2.15a14.32,14.32,0,0,0,2.05-5l2.78-.26V34l-2.78-.26a14.32,14.32,0,0,0-2.05-5l1.77-2.15-3.8-3.81L58.3,24.61a14.32,14.32,0,0,0-5-2.05l-.26-2.78H47.68l-.27,2.78a14.35,14.35,0,0,0-5,2.05l-2.15-1.78-3.81,3.81Zm17.26,2.78a7.29,7.29,0,1,1-10.31,0,7.27,7.27,0,0,1,10.31,0",
    transform: "translate(0 -0.57)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 144.93,
    cy: 63.41,
    r: 11.57
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M71.28,172.76H44a1.59,1.59,0,0,1-1.58-1.59V144A1.58,1.58,0,0,1,44,142.39H71.28A1.59,1.59,0,0,1,72.87,144v27.2a1.59,1.59,0,0,1-1.59,1.59",
    transform: "translate(0 -0.57)"
  })))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M72.87,146.16H42.45v-2.29a1.48,1.48,0,0,1,1.48-1.48H71.41a1.46,1.46,0,0,1,1.46,1.46Z",
    transform: "translate(0 -0.57)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M69.72,144.33a.8.8,0,1,1-.8-.8.8.8,0,0,1,.8.8",
    transform: "translate(0 -0.57)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M67.45,144.3a.8.8,0,1,1-.8-.8.8.8,0,0,1,.8.8",
    transform: "translate(0 -0.57)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M65.18,144.3a.8.8,0,1,1-.8-.8.8.8,0,0,1,.8.8",
    transform: "translate(0 -0.57)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M65.48,150.81v4.45h-.43a7.15,7.15,0,0,0-.86-2.21,3.28,3.28,0,0,0-1.3-1.07,4,4,0,0,0-1.61-.22H60.06v12.66A5.31,5.31,0,0,0,60.2,166a1.23,1.23,0,0,0,.54.55,2.29,2.29,0,0,0,1.11.23h.55v.45H53.8v-.45h.55a2.28,2.28,0,0,0,1.15-.25A1.15,1.15,0,0,0,56,166a5.07,5.07,0,0,0,.13-1.53V151.76H54.94a3.44,3.44,0,0,0-2.41.7,4.62,4.62,0,0,0-1.33,2.8h-.46v-4.45Z",
    transform: "translate(0 -0.57)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-19",
    transform: "translate(339.62 145.02)"
  }, "LOGO &amp;", /*#__PURE__*/React.createElement("tspan", {
    x: -74.55,
    y: 40
  }, "VISUAL ELEMENTS"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 328.34,
    y: 107.58,
    width: 121.53,
    height: 44.52
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 326.38,
    y: 104.25,
    width: 3.91,
    height: 5.38
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 326.22,
    y: 150.06,
    width: 3.82,
    height: 5.26
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 388.09,
    y: 105.14,
    width: 3.55,
    height: 4.88
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 387.63,
    y: 149.59,
    width: 3.65,
    height: 5.02
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 448.05,
    y: 105.08,
    width: 3.65,
    height: 5.01
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 448.05,
    y: 149.6,
    width: 3.65,
    height: 5.01
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M629.66,120.88c.31,1.46,1.22,5.61-.8,9.24-1.1,2-2.46,2.72-3.46,5.45s-.14,3.51-1,5.11c-2,3.75-9.8,5.15-13.43,2.28-1.44-1.14-1.17-2.11-3.36-4.05s-3.47-2-5.05-3.08c-3.66-2.44-4.62-7.1-4.89-8.4-1.42-6.91,2.93-17.26,12.72-19.27s17.78,5.89,19.28,12.72",
    transform: "translate(0 -0.57)"
  })))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M629.66,120.88c.31,1.46,1.22,5.61-.8,9.24-1.1,2-2.46,2.72-3.46,5.45s-.14,3.51-1,5.11c-2,3.75-9.8,5.15-13.43,2.28-1.44-1.14-1.17-2.11-3.36-4.05s-3.47-2-5.05-3.08c-3.66-2.44-4.62-7.1-4.89-8.4-1.42-6.91,2.93-17.26,12.72-19.27s17.78,5.89,19.28,12.72",
    transform: "translate(0 -0.57)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M624,143.15l-11.47,2.35a2.17,2.17,0,0,1-.87-4.26l11.47-2.35a2.17,2.17,0,0,1,.87,4.26",
    transform: "translate(0 -0.57)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M625.51,148.81l-11.64,2.39a2.08,2.08,0,1,1-.83-4.08l11.64-2.39a2.08,2.08,0,1,1,.83,4.08",
    transform: "translate(0 -0.57)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M626.42,154.8l-11,2.26a2.4,2.4,0,1,1-1-4.7l11-2.26a2.4,2.4,0,1,1,1,4.7",
    transform: "translate(0 -0.57)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M615,140.55s-.79-8.42-2.6-10.65-2.77,2.62-.85,2.46a4.57,4.57,0,0,0,3.85-3.18c.67-1.7-2.24-3.39-1.45-.85s4,1.68,5,1.58-.75-4.64-1.46-2.51.38,2.83,1.18,4.23,1.81,7.79,1.81,7.79",
    transform: "translate(0 -0.57)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M607.38,112.28c1.22.92.93,3.34-.64,5.42s-3.83,3-5,2.11-.92-3.35.65-5.42,3.82-3,5-2.11",
    transform: "translate(0 -0.57)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M608.61,111.2c1.7,1.28,1.3,4.68-.9,7.6s-5.36,4.23-7.06,2.94-1.3-4.68.9-7.59,5.36-4.24,7.06-3",
    transform: "translate(0 -0.57)"
  })))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M625.31,160.44l-5.92,1.21a2.59,2.59,0,0,1-3-2l-.23-1.13a2.59,2.59,0,0,1,2-3l5.92-1.21a2.59,2.59,0,0,1,3.05,2l.23,1.13a2.6,2.6,0,0,1-2,3.05",
    transform: "translate(0 -0.57)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 624.76,
    y1: 104.73,
    x2: 630.04,
    y2: 98.96
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 612.51,
    y1: 104.42,
    x2: 610.94,
    y2: 96.75
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 602.41,
    y1: 107.65,
    x2: 597.48,
    y2: 101.57
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 596.07,
    y1: 115.67,
    x2: 588.65,
    y2: 113.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 594.79,
    y1: 124.96,
    x2: 587.12,
    y2: 126.53
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 597.35,
    y1: 133.54,
    x2: 591.3,
    y2: 138.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 630.03,
    y1: 114.15,
    x2: 637.75,
    y2: 112.87
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 633.22,
    y1: 124.29,
    x2: 640.84,
    y2: 126.08
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M698.23,56.3l-35,8.35a2.94,2.94,0,0,1-3.54-2.17l-8.34-34.9a2.94,2.94,0,0,1,2.18-3.53l35-8.36a2.94,2.94,0,0,1,3.54,2.17l8.33,34.9a2.94,2.94,0,0,1-2.17,3.54",
    transform: "translate(0 -0.57)"
  })))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M687.8,18.61a1.1,1.1,0,0,1-2.14.51,1.1,1.1,0,1,1,2.14-.51",
    transform: "translate(0 -0.57)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M684.75,19.29a1.1,1.1,0,1,1-1.32-.81,1.09,1.09,0,0,1,1.32.81",
    transform: "translate(0 -0.57)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M681.72,20a1.11,1.11,0,0,1-.82,1.33,1.1,1.1,0,1,1,.82-1.33",
    transform: "translate(0 -0.57)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 665.69,
    y: 31.44,
    width: 20.96,
    height: 20.96,
    transform: "translate(8.77 157.75) rotate(-13.44)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M678.82,52.38s8.33-11.23,8.36-11.07l2.06,8.58Z",
    transform: "translate(0 -0.57)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M710.51,233.78l-11.76-6.05,3.21-5.37a1.92,1.92,0,0,0-1.41-2.88l-32.5-4.09a1.91,1.91,0,0,0-1.85,2.93l18.19,28.11a1.91,1.91,0,0,0,3.25-.06l3.68-6.18,11.47,7.89a2.27,2.27,0,0,0,3.31-.83l5.39-10.39a2.29,2.29,0,0,0-1-3.08",
    transform: "translate(0 -0.57)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 371.13,
    cy: 47.23,
    r: 11.07
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogovisualelementstab);
export default __webpack_public_path__ + "static/media/logo & visual elements tab.cb3e5c93a542f56c15d0adad08356b0b.svg";
export { ForwardRef as ReactComponent };